import type { AttackCategory } from '../services/incidents';

// Sessão 1 Frente A — badge color-coded por attack_category.
// 11 categorias canônicas + UNKNOWN. Cores escolhidas pra contrast em dark theme.

const CATEGORY_STYLES: Record<AttackCategory, { bg: string; fg: string; label: string }> = {
  PACKET_SNIFFER:   { bg: 'bg-red-900',     fg: 'text-red-100',     label: 'Captura de pacotes' },
  MEMORY_HACK:      { bg: 'bg-red-800',     fg: 'text-red-100',     label: 'Memória do jogo' },
  DEBUGGER:         { bg: 'bg-orange-800',  fg: 'text-orange-100',  label: 'Depurador' },
  INJECTION:        { bg: 'bg-purple-800',  fg: 'text-purple-100',  label: 'Injeção de código' },
  GAME_TAMPERING:   { bg: 'bg-rose-900',    fg: 'text-rose-100',    label: 'Arquivos do jogo' },
  KERNEL_TOOLING:   { bg: 'bg-pink-900',    fg: 'text-pink-100',    label: 'Núcleo do Windows' },
  RECON:            { bg: 'bg-yellow-800',  fg: 'text-yellow-100',  label: 'Reconhecimento' },
  OVERLAY:          { bg: 'bg-blue-800',    fg: 'text-blue-100',    label: 'Sobreposição de tela' },
  TIMING:           { bg: 'bg-cyan-800',    fg: 'text-cyan-100',    label: 'Tempo / automação' },
  INTEGRITY:        { bg: 'bg-emerald-800', fg: 'text-emerald-100', label: 'Integridade' },
  UNKNOWN:          { bg: 'bg-gray-700',    fg: 'text-gray-200',    label: 'Não classificado' },
};

interface Props {
  category: string;  // aceita qualquer string — UNKNOWN se não match
  className?: string;
}

export function AttackCategoryBadge({ category, className = '' }: Props) {
  const cat = (category as AttackCategory) || 'UNKNOWN';
  const style = CATEGORY_STYLES[cat] ?? CATEGORY_STYLES.UNKNOWN;
  return (
    <span
      className={`inline-block px-2 py-0.5 rounded text-xs font-medium ${style.bg} ${style.fg} ${className}`}
      title={cat}
    >
      {style.label}
    </span>
  );
}

export default AttackCategoryBadge;
